import { MajSiteComponent } from './layouts/footer/maj-site/maj-site.component';
import { Route } from '@angular/router';

import { MentionLegaleComponent } from './layouts/footer/mention-legale/mention-legale.component';
import { ConditionGeneraleComponent } from './layouts/footer/condition-generale/condition-generale.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import {AccessibiliteComponent} from './layouts/footer/accessibilite/accessibilite.component';
import { UserRouteAccessService } from './shared';
import { PAGE_TITLE_SUFFIX } from './app.constants';
import {PersonalDataComponent} from './layouts/footer/personal-data/personal-data.component';

export const navbarRoute: Route = {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar'
};

export const mentionLegaleRoute: Route = {
    path: 'mentions-legales',
    component: MentionLegaleComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Mentions légales${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};

export const conditionGeneraleRoute: Route = {
    path: 'conditions-generales',
    component: ConditionGeneraleComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Conditions générales d\'utilisation${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};

export const accessibiliteRoute: Route = {
    path: 'accessibilite',
    component: AccessibiliteComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Accessibilité : partiellement conforme${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};

export const personalDataRoute: Route = {
    path: 'donnees-personelles',
    component: PersonalDataComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Données personnelles${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};

export const changelogRoute: Route = {
    path: 'changelog',
    component: MajSiteComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Mises à jour du site${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.route.ts